angular.module("questionarioAdv.module")
  .component("titolari", {
    templateUrl: "ng/components/questionarioAdv/titolari/titolari.view.html",
    bindings: {
      model: "=",
      newTitolariAdd: '&',
      exportValidationComponent: '&',
      domini: '<',
      formGiurCli: '<',
      resetSupportModel: '<',
      startQuestionario: '<',
      isPagoDopo: '<',
      clienteIsAzienda: '<',
      clienteIsCoc: '<',
      checkFiduciariaSelected: '<',
      listaNazioni: '<',
      submitError: '<',
      externalLink: '<',
      readOnly:'<',
      isPostVendita: '<',
      ndgCli: '<'
    },
    controllerAs: 'titolariCtrl',
    controller: Titolari
  })

function Titolari(
  $istatService,
  $rootScope,
  $typeDomainService,
  $scope,
  Documento,
  Sede,
  validationService,
  Stato,
  $timeout,
  $configService,
  $financialApiService,
  $modalService,
  FileUploader,
  $simulationService,
  $userService,
  $portalService,
  Pf,
  $instantService,
  $uniService,
  $download
) {
  var self = this;

  self.$onInit = function () {
    self.isAru = $portalService.isAru();
    self.newTitAdded = [];
    self.dealerUser = {};
    self.mapComuni = $rootScope.comuniMap;
    self.documentUpload = [];
    self.listaNomeRilascio = [];
    self.listaNomeRilascioNew = [];
    self.enablePreviusJob = [];
    self.listaNomeComuniRilascio = [];
    self.listaComuniNascita = [];
    self.testDati = [];
    self.supportModel = [];
    self.supportnewTitAdded = []
    self.uploadDocumentSelect = "upload"
    self.validationObj = {
      documentDate: {
        disabledDays: [0],
        disabledDates: [
          "01-01",
          "06-01",
          "25-04",
          "01-05",
          "02-06",
          "15-08",
          "01-11",
          "08-12",
          "25-12",
          "26-12"
        ]
      }
    };
    self.linkPep = '/uni/download/service-infos/' +
      encodeURIComponent('GLOSSARIO') + '/';
    self.cfIsNotRequired = [];
    self.modelCopied = self.model && self.model[0];
    self.today = self.getTodaysDate();
    // self.newTitAdded = self.model.filter(function (element) {
    //   return !element.ndg
    // });
    // self.newTitAdded.forEach(function (element, index) {
    //   self.listaComuniNascita[index] = self.mapComuni
    //     .filter(function (comune) {
    //       return comune.sigla == element.datiNascita.provincia;
    //     });
    //   if (element.datiNascita.provincia && element.datiNascita.provincia.toUpperCase() != 'EE' && element.datiNascita.provincia.toUpperCase() != 'SE') {
    //     self.verifyDate(index, true)
    //   }
    // })
    // self.model = self.model.filter(function (element) {
    //   return element.ndg
    // });
    self.model.forEach(function (element, index) {
      if (element && element.sedeLegale && element.sedeLegale.stato) {
        element.sedeLegale.stato.name = element.sedeLegale.stato.name && element.sedeLegale.stato.name.toUpperCase();
      }
      if (element && !element.documento) {
        element.documento = Documento.build();
      }
      self.listaNomeRilascio[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
      self.supportModel.push({
        ruolo: null,
        professione: null,
        professionePrec: null,
        relazionePep: null,
        originePatrimonio: null,
        settore: null,
        areaGeoSvolgimento: null,
        relazioneTitCliente: null
      })
    })
    self.dropdown = {
      tipiDocumento: []
    }
    self.tomorrow = moment()
      .add(1, "days")
      .format("DD/MM/YYYY");
    self.listaNomeComuni = {
      rilascio: []
    }

    getListaProvince();
    getListaDocumenti();
    setDefaulValue();
    validateComponent();
    $timeout(function () {
      self.validatingComponent();
    }, 200)
  }

  self.downloadLinkPep = () => {

    $download.getGenericDownload(self.linkPep)
      .then(function (response) {
        console.log(response);
      })
  }

  self.$onChanges = function (changed) {
    if (changed && changed.resetSupportModel && typeof changed.resetSupportModel.currentValue != "undefined") {
      self.newTitAdded = [];
    }

    if (changed && changed.checkFiduciariaSelected && typeof changed.checkFiduciariaSelected.currentValue != "undefined") {
      validateComponent();
    }
    if (changed && changed.listaNazioni && changed.listaNazioni.currentValue) {
      self.nationCitizenship = self.listaNazioni.filter(
        function (element) {
          return !element.deleted
        }).map(function (element) {
          return element.name.toUpperCase();
        }).sort();
    }

    if (changed && changed.submitError && typeof changed.submitError.currentValue != "undefined") {
      //ricreaModelli();
    }
  }

  self.handleChange = function (tipo, subType, valueSelected, indice, tipologia) {
    if (tipologia === 'titAdded') {
      if (subType) {
        self.newTitAdded[indice][tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })

      } else {
        self.newTitAdded[indice][tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }

      if (tipo === 'professione') {
        if (valueSelected.name === "Casalinga" || valueSelected.name === "Pensionato" || valueSelected.name === "Non occupato") {
          self.enablePreviusJob[self.model.length + indice] = true;
        } else {
          self.enablePreviusJob[self.model.length + indice] = false;
        }
      }
    } else {
      if (subType) {
        self.model[indice][tipo][subType].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })

      } else {
        self.model[indice][tipo].forEach(function (element) {
          if (element.value == valueSelected.value) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        })
      }

      if (tipo === 'professione') {
        if (valueSelected.name === "Casalinga" || valueSelected.name === "Pensionato" || valueSelected.name === "Non occupato") {
          self.enablePreviusJob[indice] = true;
        } else {
          self.enablePreviusJob[indice] = false;
        }
      }

    }
    validateComponent();
  }

  var getListaDocumenti = function () {

    $typeDomainService
      .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
      .then(function (response) {
        self.dropdown.tipiDocumento = response.domainList;
        for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
          if (self.dropdown.tipiDocumento[i].value == "CAE") {
            self.dropdown.tipiDocumento[i].order = 40;
          }
          if (self.dropdown.tipiDocumento[i].value == "CAI") {
            self.dropdown.tipiDocumento[i].order = 10;
          }
          if (self.dropdown.tipiDocumento[i].value == "CIE") {
            self.dropdown.tipiDocumento[i].order = 20;
          }
          if (self.dropdown.tipiDocumento[i].value == "NCE") {
            self.dropdown.tipiDocumento[i].order = 30;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAM") {
            self.dropdown.tipiDocumento[i].order = 50;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAS") {
            self.dropdown.tipiDocumento[i].order = 80;
          }
          if (self.dropdown.tipiDocumento[i].value == "PAT") {
            self.dropdown.tipiDocumento[i].order = 60;
          }
          if (self.dropdown.tipiDocumento[i].value == "UCO") {
            self.dropdown.tipiDocumento[i].order = 70;
          }

        }
      });
  }

  self.setDocNumRegex = function (indice, tipo) {

    if (tipo === 'titAdded') {
      self.listaNomeRilascioNew[indice] = Documento.getEntiRilascio(
        self.newTitAdded[indice].documento.tipo
      );
      self.newTitAdded[indice].documento.numero = null;
    } else {
      self.listaNomeRilascio[indice] = Documento.getEntiRilascio(
        self.model[indice].documento.tipo
      );
      self.model[indice].documento.numero = null;
    }
    self.refreshRegex = true;
    $timeout(function () {
      self.refreshRegex = false;
      validateComponent();
    }, 200)

    if (tipo === 'titAdded' && self.newTitAdded[indice].ndg && !self.isPagoDopo) {
      $financialApiService
        .getIdentityDocument(
          self.newTitAdded[indice].ndg,
          self.newTitAdded[indice].documento.tipo
        )
        .then(function (response) {
          if (response.success) {
            self.newTitAdded[indice].documento.dataRilascio =
              response.document.dataRilascio;
            self.newTitAdded[indice].documento.dataScadenza =
              response.document.dataScadenza;
            self.newTitAdded[indice].documento.luogoEsteso = {
              nome: response.document.luogo,
            };
            self.newTitAdded[indice].documento.enteRilascio.name =
              response.document.enteRilascio;
            self.newTitAdded[indice].documento.provincia =
              response.document.provincia;
            self.newTitAdded[indice].documento.numero = response.document.numero;
            self.newTitAdded[indice].documento.id = response.document.id;
          }
          $timeout(function () {
            validateComponent();
          }, 1000)
        })
        .catch(function (error) {
          console.log(error);
        });

    } else if (self.model && self.model[indice] && self.model[indice].ndg && tipo != 'titAdded' && !self.isPagoDopo) {
      $financialApiService
        .getIdentityDocument(
          self.model[indice].ndg,
          self.model[indice].documento.tipo
        )
        .then(function (response) {
          if (response.success) {
            self.model[indice].documento = Documento.build({
              tipo: self.model[indice].documento.tipo
            });
            self.model[indice].documento.dataRilascio =
              response.document.dataRilascio;
            self.model[indice].documento.dataScadenza =
              response.document.dataScadenza;
            self.model[indice].documento.luogoEsteso = {
              nome: response.document.luogo,
            };
            self.model[indice].documento.enteRilascio.name =
              response.document.enteRilascio;
            self.model[indice].documento.provincia =
              response.document.provincia;
            self.model[indice].documento.numero = response.document.numero;
            self.model[indice].documento.id = response.document.id;
          }
          $timeout(function () {
            validateComponent();
          }, 1000)
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      switch (tipo) {
        case 'titAdded':
          self.newTitAdded[indice].documento = Documento.build({
            tipo: self.newTitAdded[indice].documento.tipo
          });
          break;
        default:
          self.model[indice].documento = Documento.build({
            tipo: self.model[indice].documento.tipo
          });
      }
    }

  }

  var getListaProvince = function () {
    self.listaProvince = self.mapComuni
      .map(function (comune) {
        return comune.sigla;
      })
      .filter(function (siglaComune) {
        return siglaComune != "";
      })
      .sort()
      .reduce(function (result, nextItem) {
        return result.includes(nextItem) ? result : result.concat(nextItem);
      }, []);
    self.listaProvince.push("EE");

  }

  self.creaComuni = function (indice, provincia, tipo) {
    if (tipo === 'newTitAdded') {

      if (provincia != 'EE') {
        self.listaNomeComuniRilascio[self.model.length + indice] = self.mapComuni
          .filter(function (comune) {
            return comune.sigla == provincia;
          });
      }

    } else {
      if (provincia != 'EE') {
        self.listaNomeComuniRilascio[indice] = self.mapComuni
          .filter(function (comune) {
            return comune.sigla == provincia;
          });
      }
    }
    validateComponent();
  }

  var getListNazioni = function () {
    $istatService.getNazioni()
      .then(function (response) {
        self.listaNazioni = response.domainList.filter(
          function (element) {
            return !element.deleted
          });
        self.nationCitizenship = response.domainList.filter(
          function (element) {
            return !element.deleted
          }).map(function (element) {
            return element.name.toUpperCase();
          }).sort();
      })
  }

  self.radioModify = function (tipo, valore, indice, isnewTit) {
    if (tipo == 'pep') {
      if (!valore) {
        if (isnewTit) {
          var iesimo = self.model.length + indice;
          self.supportModel[iesimo].caricaIstituzionale = null;
          self.supportModel[iesimo].relazionePep = null;
        } else {
          self.supportModel[indice].caricaIstituzionale = null;
          self.supportModel[indice].relazionePep = null;
        }
      }

      if (isnewTit) {
        self.newTitAdded[indice].pep.carica.forEach(function (element) {
          element.selected = false;
        })
        self.newTitAdded[indice].pep.relazione.forEach(function (element) {
          element.selected = false;
        })

      } else {

        self.model[indice].pep.carica.forEach(function (element) {
          element.selected = false;
        })
        self.model[indice].pep.relazione.forEach(function (element) {
          element.selected = false;
        })
      }

    }
    validateComponent();
  }

  self.addTitolare = function () {
    var newTit = createNewTit();
    self.newTitAdded.push(newTit)
    validateComponent();
  }

  self.removeTit = function (indice) {
    self.newTitAdded.splice(indice, 1);
    self.supportModel.splice(self.model.length + indice, 1);
    validateComponent();
  }

  self.removeDefault = function (indice) {
    self.model.splice(indice, 1);
    validateComponent();
  }

  var createNewTit = function (dateOfRest) {
    var newTit = {
      area: self.domini.area,
      cf: dateOfRest && dateOfRest.cf || null,
      cognome: dateOfRest && dateOfRest.cognome || null,
      data: dateOfRest && dateOfRest.datiNascita.data || null,
      datiNascita: {
        cap: null,
        cittadinanza: dateOfRest && dateOfRest.datiNascita.cittadinanza || null,
        comune: dateOfRest && dateOfRest.datiNascita.comune || null,
        indirizzo: null,
        nazione: dateOfRest && dateOfRest.datiNascita.nazione || null,
        provincia: dateOfRest && dateOfRest.datiNascita.provincia || null
      },
      descrizione: self.domini.descrizione,
      documento: dateOfRest && Documento.build(dateOfRest.documento) || Documento.build(),
      domicilio: dateOfRest && dateOfRest.domicilio || null,
      domicilioDiverso: dateOfRest && dateOfRest.domicilioDiverso || false,
      editable: true,
      id: "pef",
      ndg: dateOfRest && dateOfRest.ndg || null,
      nome: dateOfRest && dateOfRest.nome || null,
      originePatrimonio: self.domini.originePatrimonio,
      originePatrimonioMex: null,
      pep: {
        carica: self.domini.carica,
        description: "pep_base",
        editable: false,
        id: "pep_base",
        origineFondi: self.domini.origineFondi,
        origineFondiDescr: null,
        paeseOrigine: null,
        pep: false,
        pepFinanziamenti: false,
        relazione: self.domini.relazione,
        relazioneDescr: null,
        visible: false
      },
      professione: self.domini.professione,
      professionePrec: self.domini.professionePrec,
      ragioneSociale: null,
      relazioneTitCli: self.domini.relazioneTitCli,
      sedeLegale: Sede.build(dateOfRest && dateOfRest.sedeLegale),
      settore: self.domini.settore,
      isEstero: dateOfRest && dateOfRest.isEstero

    }
    self.supportModel.push({
      ruolo: null,
      professione: null,
      professionePrec: null,
      relazionePep: null,
      originePatrimonio: null,
      settore: null,
      areaGeoSvolgimento: null,
      relazioneTitCliente: null
    })

    return newTit;

  }

  self.creaComuniNascita = function (indice, provincia) {

    if (provincia != 'EE') {
      self.listaComuniNascita[indice] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == provincia;
        });
      if (self.newTitAdded && self.newTitAdded[indice] && self.newTitAdded[indice].datiNascita.nazione) {
        self.newTitAdded[indice].datiNascita.nazione = 'Italia';
      }

    }
    validateComponent();
  }

  self.setDataNascita = function (indice, value) {
    self.newTitAdded[indice].data = value;
    self.verifyDate(indice);
    validateComponent();
  }

  self.verifyDate = function (indice, init) {
    if (!init) {
      if (indice == self.newTitAdded.length - 1 && self.newTitAdded[indice].cf && checkIfTitIsPresent(self.newTitAdded[indice].cf)) {

        return

      }
    }
    var sesso = "";
    calculateFakeCf(indice)
    if (!self.newTitAdded[indice].cf) {
      sesso = self.newTitAdded[indice].sesso
    } else {
      var giornoNascita = self.newTitAdded[indice].cf && self.newTitAdded[indice].cf.substring(9, 11);
      sesso = giornoNascita > 40 ? 'F' : 'M'
    }
    var codCat = "";
    if (self.newTitAdded[indice].datiNascita.provincia != 'EE') {
      codCat = self.newTitAdded[indice].datiNascita.comune &&
        self.mapComuni.find(function (element) {
          return element.nome.toUpperCase() == self.newTitAdded[indice].datiNascita.comune.toUpperCase()
        }).codiceCatastale;
    } else {
      codCat = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == self.newTitAdded[indice].datiNascita.nazione.toUpperCase();
      }).value
    }
    self.testDati[indice] = validationService.checkCfWithFieds(
      self.newTitAdded[indice].cf,
      self.newTitAdded[indice].nome,
      self.newTitAdded[indice].cognome,
      self.newTitAdded[indice].data,
      sesso,
      codCat
    );
    validateComponent();
  };


  var validateComponent = function () {
    $timeout(function () {

      var checkFileIsUploadedModel = self.model.every(function (element) {
        return (element.documento &&
          element.documento.idImgDocumentoFront) ||
          element.annullato ||
          element.annullatoFe
      })

      var checkFileIsUploadedNewTit = self.newTitAdded.every(function (element) {
        return element.documento && element.documento.idImgDocumentoFront
      })

      var testSesso = self.newTitAdded.filter(function (element) {
        return !!!element.cf
      }).every(function (sex) {
        return sex.sesso != null;
      })
      var leastOne = true;
      if ((self.clienteIsAzienda.visible || self.clienteIsCoc.visible) && !self.checkFiduciariaSelected) {
        leastOne = self.model.length > 0 || self.newTitAdded.length > 0;
      }

      var testComponentValid = $scope.titolariForm.$valid &&
        checkFileIsUploadedModel &&
        checkFileIsUploadedNewTit &&
        testSesso &&
        leastOne;
      // console.log("Il form è:", testComponentValid);

      // self.newTitolariAdd({
      //   nuoviTitolari: self.newTitAdded
      // })


      // self.exportValidationComponent({
      //   valid: testComponentValid
      // })

    }, 500)

  }

  self.validatingComponent = function () {
    var tempTitArray =
      self.model &&
      self.model.length &&
      self.model.filter((tit) => {
        return !tit.annullato && !tit.annullatoFe && !tit.hide;
      });
    if (tempTitArray.length) {
      var testComponentValid = tempTitArray.every((x) => {
        return x.isOk == true;
      });
    }
    console.log("Il form titolari è:", testComponentValid);
    self.exportValidationComponent({
      valid: testComponentValid
    })
  }

  self.handleChangeClassicVersion = function (name, value, indice) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.model[indice].documento.numero = value
        break;

      case 'dataScadenza':
        self.model[indice].documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.model[indice].documento.dataRilascio = value;
        break;

      default:
        break;
    }
    validateComponent();
  }

  self.handleChangeClassicVersionNewTit = function (name, value, indice) {
    console.log(name)
    switch (name) {
      case 'number-document':
        self.newTitAdded[indice].documento.numero = value
        break;

      case 'dataScadenza':
        self.newTitAdded[indice].documento.dataScadenza = value;
        break;

      case 'dataRilascio':
        self.newTitAdded[indice].documento.dataRilascio = value;
        break;

      default:
        break;
    }
    validateComponent();
  }

  self.getTodaysDate = function () {

    return moment().format("DD/MM/YYYY");
  }


  self.getEndDate = function (dataRilascio, index, value) {
    if (dataRilascio) {
      var tipoDocumento = self.model[index].documento.tipo;
      var dataNascita = self.model[index].data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.titolariForm && $scope.titolariForm[value] && moment.duration(moment(self.model[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.titolariForm[value].$valid = false;
        }
        if ($scope.titolariForm && $scope.titolariForm[value] && moment.duration(moment(self.model[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.titolariForm[value].$valid = false;
          $scope.titolariForm[value].$setValidity("dataScadenza", false);
        } else {
          $scope.titolariForm && $scope.titolariForm[value] && $scope.titolariForm[value].$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.model[index].documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.titolariForm[value].$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  self.getEndDateNewTit = function (dataRilascio, index, value) {
    if (dataRilascio) {
      var tipoDocumento = self.newTitAdded[index].documento.tipo;
      var dataNascita = self.newTitAdded[index].data;
      var dataRilascio = moment(dataRilascio, "DD/MM/YYYY");
      var startYear = moment(dataRilascio).format("YYYY");
      var startDay = moment(dataRilascio).format("DD");
      var startMonth = moment(dataRilascio).format("MM");

      var endDate = moment(dataRilascio)
        .add(10, "years")
        .format("DD/MM/YYYY");

      if (
        tipoDocumento === propMap["DOC_TYPE_CAI"] ||
        tipoDocumento === propMap["DOC_TYPE_NCE"] ||
        tipoDocumento === propMap["DOC_TYPE_CIE"] ||
        tipoDocumento === propMap["DOC_TYPE_CAE"] ||
        tipoDocumento === propMap["DOC_TYPE_PAT"] ||
        tipoDocumento === propMap['DOC_TYPE_PAM'] ||
        tipoDocumento === propMap['DOC_TYPE_UCO'] ||
        self.isM17Map
      ) {
        var dataNascita = moment(dataNascita, "DD/MM/YYYY");
        var birthYear = moment(dataNascita).format("YYYY");
        var birthDay = moment(dataNascita).format("DD");
        var birthMonth = moment(dataNascita).format("MM");

        if (birthMonth == '02' && birthDay == '29') {
          birthMonth = '03';
          birthDay = '01';
        }

        var futureBirthDay = moment(
          birthDay + "/" + birthMonth + "/" + startYear,
          "DD/MM/YYYY"
        )
          .add(10, "years")
          .format("DD/MM/YYYY");
        //console.log("Compleanno Futuro: " + futureBirthDay);

        var daysDiff = moment
          .duration(
            moment(endDate, "DD/MM/YYYY").diff(
              moment(futureBirthDay, "DD/MM/YYYY")
            )
          )
          .asDays();

        var expiryDate;
        if (daysDiff <= 0) {
          expiryDate = moment(futureBirthDay, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
        } else {
          expiryDate = moment(
            birthDay + "/" + birthMonth + "/" + startYear,
            "DD/MM/YYYY"
          )
            .add(11, "years")
            .format("DD/MM/YYYY");
        }

        while (
          (moment(expiryDate, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY")) <= 0) &&
          ((tipoDocumento === propMap["DOC_TYPE_CAI"]) || (tipoDocumento === propMap["DOC_TYPE_PAT"]))) {
          expiryDate = moment(
            expiryDate,
            "DD/MM/YYYY"
          )
            .add(10, "years")
            .format("DD/MM/YYYY");
        }

        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        expiryDate = moment(expiryDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19

        if ($scope.titolariForm && $scope.titolariForm[value] && moment.duration(moment(self.newTitAdded[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(expiryDate, "DD/MM/YYYY"))).asDays() > 0) {
          $scope.titolariForm[value].$valid = false;
        }
        if ($scope.titolariForm && $scope.titolariForm[value] && moment.duration(moment(self.newTitAdded[index].documento.dataScadenza, "DD/MM/YYYY").diff(moment(self.today, "DD/MM/YYYY"))).asDays() < 2) {
          $scope.titolariForm[value].$valid = false;
          $scope.titolariForm[value].$setValidity("dataScadenza", false);
        } else {
          $scope.titolariForm && $scope.titolariForm[value] && $scope.titolariForm[value].$setValidity("dataScadenza", true);
        }
        return expiryDate;
      } else {
        /* aumentiamo l'anno di scadenza di tutti i documenti di 2 anni e 3 mesi vista l'emergenza COVID19 */
        endDate = moment(endDate, "DD/MM/YYYY")
          .add(2, "years")
          .add(3, "months")
          .format("DD/MM/YYYY");
        //fine campo aggiunto per emergenza COVID19
        if (
          moment
            .duration(
              moment(
                self.newTitAdded[index].documento.dataScadenza,
                "DD/MM/YYYY"
              ).diff(moment(endDate, "DD/MM/YYYY"))
            )
            .asDays() > 0
        ) {
          $scope.titolariForm[value].$valid = false;
        }
        return endDate;
      }
    } else {
      return moment(self.today, "DD/MM/YYYY")
        .add(10, "years")
        .format("DD/MM/YYYY");
    }

  };

  var setDefaulValue = function () {
    self.model && self.model.forEach(function (element, index) {
      self.supportModel[index].relazioneTitCliente = element.relazioneTitCli && element.relazioneTitCli.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].professione = element.professione && element.professione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].professionePrec = element.professionePrec && element.professionePrec.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].settore = element.settore && element.settore.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].areaGeoSvolgimento = element.area && element.area.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].originePatrimonio = element.originePatrimonio && element.originePatrimonio.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].caricaIstituzionale = element.pep && element.pep.carica && element.pep.carica.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].relazionePep = element.pep && element.pep.relazione && element.pep.relazione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportModel[index].originePatrimonioPEP = element.pep && element.pep.origineFondi && element.pep.origineFondi.find(function (sel) {
        return sel.selected == true;
      })

    })

    // set defaul value new tit
    self.newTitAdded && self.newTitAdded.forEach(function (element, index) {
      self.supportnewTitAdded[index].relazioneTitCliente = element.relazioneTitCli && element.relazioneTitCli.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].professione = element.professione && element.professione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].professionePrec = element.professionePrec && element.professionePrec.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].settore = element.settore && element.settore.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].areaGeoSvolgimento = element.area && element.area.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].originePatrimonio = element.originePatrimonio && element.originePatrimonio.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].caricaIstituzionale = element.pep && element.pep.carica && element.pep.carica.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].relazionePep = element.pep && element.pep.relazione && element.pep.relazione.find(function (sel) {
        return sel.selected == true;
      })

      self.supportnewTitAdded[index].originePatrimonioPEP = element.pep && element.pep.origineFondi && element.pep.origineFondi.find(function (sel) {
        return sel.selected == true;
      })

    })


  }

  self.searchTitolare = function () {
    self.enableModalSearch = true;
    self.supportTitModel = {}
    $("#footerInstant").css("z-index", "-1");
    $('.financial-leasing__footer').css("z-index", "-1");
    $timeout(function () {
      $modalService.openModal('ricercaTitolare-modal');

    }, 200)


  }

  self.closeModal = function () {
    $modalService.closeModal('ricercaTitolare-modal');
    self.enableModalSearch = false;
  }

  self.closeModalUploadDocument = function () {
    $modalService.closeModal('modalUploadDocument');
    self.enableModalDocument = false;
    self.titolareIesimo = Object.assign({});
    self.documentUpload = [];
    validateComponent();
  }

  self.addTitSearch = function (user) {
    $rootScope.disableDoubleClick = true;
    self.newTitAdded = self.newTitAdded && self.newTitAdded.filter(function (titolare) {
      return titolare.cf != null;
    })
    self.enableLoaderButton = true;
    $financialApiService
      .getSearchRiUserG(user)
      .then(function (listAppCustomer) {
        if (listAppCustomer.success) {
          listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.stato = listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.statoEsteso
          if (listAppCustomer.appCustomerUser.metadata.riUserG.isEstero) {
            var codCityOfBirth = self.listaNazioni.find(function (element) {
              return element.name.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione.toUpperCase()
            }).value
            if (!listAppCustomer.appCustomerUser.metadata.riUserG.sesso) {
              listAppCustomer.appCustomerUser.metadata.riUserG.sesso = "m"
            }
            listAppCustomer.appCustomerUser.metadata.riUserG.cf = validationService.createCf(listAppCustomer.appCustomerUser.metadata.riUserG.nome, listAppCustomer.appCustomerUser.metadata.riUserG.cognome, listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.data, listAppCustomer.appCustomerUser.metadata.riUserG.sesso, codCityOfBirth)
          }
          // controllo se il cf è già presente in mappa
          var testExecutAdded = self.newTitAdded && self.newTitAdded.some(function (element) {
            return element.cf.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.cf.toUpperCase()
          })
          var testExecut = self.model && self.model.some(function (element) {
            return element.cf.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.cf.toUpperCase()
          })
          if (testExecutAdded || testExecut) {
            $rootScope.$broadcast("addAlert", {
              text: "ALREADY_ADDED"
            });
            $rootScope.disableDoubleClick = false;
            self.enableLoaderButton = false;
            return
          }
          var newUser = convertDateToTit(listAppCustomer.appCustomerUser.metadata.riUserG)
          var newTit = createNewTit(newUser);
          self.model.push(newTit);
          createListForNewTit();
          validateComponent();
        }
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal('ricercaTitolare-modal');
        self.enableModalSearch = false;
        self.enableLoaderButton = false;
      })
      .catch(function (error) {
        console.log(error);
        $rootScope.disableDoubleClick = false;
        $modalService.closeModal('ricercaTitolare-modal');
        self.enableModalSearch = false;
        self.enableLoaderButton = false;
      })
  }

  self.enabledConfirm = function (value) {
    self.enabledConfirmButton = !!value;
    self.userSelected = value;
  }

  var convertDateToTit = function (user) {
    var temp = {
      nome: user.nome,
      cognome: user.cognome,
      cf: user.cf,
      data: user.datiNascita.data,
      datiNascita: user.datiNascita,
      sedeLegale: user.sedeLegale,
      ndg: user.ndg,
      domicilioDiverso: user.domicilioDiverso,
      domicilio: user.domicilio,
      isEstero: user.isEstero,
      documento: user.documento
    }

    return temp;

  }

  var checkIfTitIsPresent = function (cf) {
    var testModel = self.model.some(function (element) {
      return element.cf.toUpperCase() == cf.toUpperCase();
    })

    var testNewAdd = self.newTitAdded.slice(0, (self.newTitAdded.length - 1))
      .some(function (element) {
        return element.cf.toUpperCase() == cf.toUpperCase();
      })

    if (testModel || testNewAdd) {
      $rootScope.$broadcast("addAlert", {
        text: "ALREADY_ADDED"
      });
      self.newTitAdded.pop();

      return true;
    }

    return false;

  }

  self.fieldChanges = function (campo, valore, indice) {
    if (valore && valore.stato && valore.stato.name && valore.stato.name.toUpperCase() != 'ITALIA' && valore.stato.name.toUpperCase() != "CAMPIONE D'ITALIA") {
      self.newTitAdded[indice].isEstero = true;
      self.cfIsNotRequired[indice] = true;
    } else {
      self.newTitAdded[indice].isEstero = false;
      self.cfIsNotRequired[indice] = false;
    }
    calculateFakeCf(indice);
    validateComponent();
  }

  var dealerUser = function () {
    if ($portalService.isAru()) {

      $userService.getDealerUser()
        .then(function (dealer) {
          if (dealer) {
            self.dealerUser = dealer;
          }
        });
    }
  }

  self.openModalDocument = function (titolare) {
    if (!titolare.cf && titolare.isEstero) {
      var codCityOfBirth = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == titolare.datiNascita.nazione.toUpperCase()
      }).value
      titolare.sesso = "m";
      titolare.cf = validationService.createCf(titolare.nome, titolare.cognome, titolare.data, titolare.sesso, codCityOfBirth)

    }
    self.titolareIesimo = titolare;
    self.enableModalDocument = true;
    if (self.titolareIesimo.documento.idImgDocumentoFront) {
      var temp = {
        name: '',
        type: "imgDocument",
        selected: false,
        side: "front",
        typeDocument: self.titolareIesimo.documento.tipo,
        downloadLink: "",
        cdDoc: self.titolareIesimo.documento.tipo,
        id: self.titolareIesimo.documento.idImgDocumentoFront,
        downloadKey: self.titolareIesimo.documento.idImgDocumentoFront
      };
      self.documentUpload.push(temp);
    }

    if (self.titolareIesimo.documento.idImgDocumentoBack) {
      var temp = {
        name: '',
        type: "imgDocument",
        selected: false,
        side: "back",
        typeDocument: self.titolareIesimo.documento.tipo,
        downloadLink: "",
        cdDoc: self.titolareIesimo.documento.tipo,
        id: self.titolareIesimo.documento.idImgDocumentoBack,
        downloadKey: self.titolareIesimo.documento.idImgDocumentoBack
      };
      self.documentUpload.push(temp);
    }

    $timeout(function () {
      $modalService.openModal('modalUploadDocument')
    }, 300)
  }

  /* inizio sezione per caricamento documenti */
  self.changeUploadMode = function () {
    self.titolareIesimo.documento.idImgDocumentoFront = "";
    self.titolareIesimo.documento.idImgDocumentoBack = "";
    self.documentUpload = [];

  }
  self.callStartMobile = function () {
    if (self.uploadDocumentSelect == 'smartphone') {
      self.startUploadDocumentMobile();
    } else {
      self.startUploadDocument();
    }

  };

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index, privacy, type, side) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ?
        arguments[3] :
        false;
    if (item) {
      self.uploadData = item;
    }
    self.typeTempDocument = type;
    self.isPrivacyUpload = privacy;
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.sideUploaded = side;
  };
  self.finalUpload = function (item) {
    console.log("calling finalUpload");
    var url =
      $configService.getAppConfig().url +
      "/uni/upload/service-infos///FINANCIAL_PD";

    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    var fileFront = document.querySelector(
      "#uploadInput_front").files[0];
    var fileBack = document.querySelector(
      "#uploadInput_back").files[0];
    var file;
    if (fileFront) {
      file = fileFront;
    } else {
      file = fileBack;
    }
    var tipo = self.titolareIesimo.documento.tipo;
    var reader = new FileReader();
    var fronte = self.sideUploaded == "front" ? true : false;
    reader.onload = function (event) {
      var formData = new FormData();
      jQuery("#uploadInput_front").val("");
      jQuery("#uploadInput_back").val("");
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "GENERAL_PERSONAL_DOCUMENTS");
      appendToForm(formData, "cdDoc", tipo);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.startQuestionario.id);
      appendToForm(formData, "personal", true);
      appendToForm(formData, "fronte", fronte);
      appendToForm(formData, "cfSoggetto", self.titolareIesimo.cf);
      appendToForm(formData, "ndgSoggetto", self.titolareIesimo.ndg);

      $uniService
        .uploadDocOnAdv(formData)
        .then(function (response) {
          if (!response.success) {
            self.visualProgBarDoc = false;
            self.disabledForUploadingInProgress = false;
            if (self.sideUploaded == "front") {
              self.disabeldUploadFront = false;
            } else {
              self.disabeldUploadBack = false;
            }
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_UPLOAD"
            });

            return;
          }

          $timeout(function () {
            var temp = {
              name: file.name,
              type: "imgDocument",
              selected: false,
              side: self.sideUploaded,
              typeDocument: self.titolareIesimo.documento.tipo,
              downloadLink: "",
              cdDoc: self.titolareIesimo.documento.tipo,
              id: response.id,
              imgDocumentoFront: response.downloadKey,
              downloadKey: response.downloadKey
            };


            if (self.sideUploaded == "front") {
              self.disabeldUploadFront = true;
            } else {
              self.disabeldUploadBack = true;
            }

            self.documentUpload.push(temp);

            self.documentUpload = self.documentUpload.filter(function (
              elem
            ) {
              return elem.name != "";
            });
            self.disableInput = false;

            self.visualProgBarDoc = false;
            if (self.sideUploaded == "front") {
              self.titolareIesimo.documento.idImgDocumentoFront = response.downloadKey;
            } else {
              self.titolareIesimo.documento.idImgDocumentoBack = response.downloadKey;

            }

            $timeout(function () {
              self.disabledForUploadingInProgress = false;
            }, 1000);
          }, 40);
        })
        .catch(function (error) {
          self.visualProgBarDoc = false;
          self.disabledForUploadingInProgress = false;
          if (self.sideUploaded == "front") {
            self.disabeldUploadFront = false;
          } else {
            self.disabeldUploadBack = false;
          }
        });

    };
    if (file) {
      reader.readAsArrayBuffer(file);
    }
  };
  self.uploader.onAfterAddingFile = function (fileItem) {
    self.disabledForUploadingInProgress = true;
    console.log("fileItem", fileItem);
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_back").val("");
      jQuery("#uploadInput_front").val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1
    ) {
      self.uploader.queue[0].progress = 100;

      self.visualProgBarDoc = true;

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      jQuery("#uploadInput_back").val("");
      jQuery("#uploadInput_front").val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;
    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disableInput = true;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) { };

  self.uploader.onErrorItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onErrorItem", fileItem, response, status, headers);
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disableInput = false;
    $timeout(function () {
      self.visualProgBarDoc = false;
    }, 4000);

    fileItem.remove();
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
  };

  self.uploader.onCancelItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {

    }
    self.uploader.queue = [];

    self.disableInput = false;
    $timeout(function () {
      self.visualProgBarDoc = false;

      self.disabledForUploadingInProgress = false;
    }, 4000);
    jQuery("#uploadInput_back").val("");
    jQuery("#uploadInput_front").val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    self.uploading = false;
  };

  self.check = function (el) {
    el.selected = !el.selected;
  };

  self.trashCanEnabledDoc = function () {
    return self.documentUpload.some(function (element) {
      return element.selected == true;
    })
  }

  self.deletePrivacyDocument = function () {
    self.progresso = 100;

    self.visualProgBarDoc = true;
    var temp = self.documentUpload;
    temp.forEach(function (element) {
      $simulationService
        .deleteChecklistFileAdv(element.id)
        .then(function (response) {
          console.log(response);
          self.progresso = 0;
          if (response.success) {
            self.documentUpload = []

            if (element.side == 'front') {
              self.titolareIesimo.documento.idImgDocumentoFront = ""
              self.disabeldUploadFront = false;
            } else {
              self.titolareIesimo.documento.idImgDocumentoBack = ""
              self.disabeldUploadBack = false;
            }

            self.uploadOk = false;
          }
          self.visualProgBarDoc = false;
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
        });

    });
  }

  self.downloadFiles = function (file) {
    var url = "/uni/downloadDocAdv/service-infos/";
    if (!self.startQuestionario.readOnly) {
      var input = {
        downloadKey: file.downloadKey
      }
    } else {
      var input = {
        downloadKey: file
      }
    }
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  }

  self.startUploadDocument = function () {
    self.enableLoader = true;
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    var person = {
      cf: self.titolareIesimo.cf,
      nome: self.titolareIesimo.nome && self.titolareIesimo.nome.toUpperCase(),
      cognome: self.titolareIesimo.cognome &&
        self.titolareIesimo.cognome.toUpperCase(),
      telefono: self.dealerUser.tel,
      documento: {
        tipo: self.titolareIesimo.documento.tipo,
      },
    };

    self.intervalOfRepeatListenMobileCapture = 0;
    var numberOfIteration = 0;
    var person = [Pf.build(person)];


    $financialApiService
      .startMobileCaptureAdv(
        person,
        self.vendorPhone,
        false,
        self.startQuestionario.id,
        self.titolareIesimo.cf,
        self.startQuestionario.metadataAdv.cliente.common.cf
      )
      .then(function (response) {
        if (response.success) {
          var inputListenMobileCapture = {
            id: response.id,
          };

          var inputForCallBackMobileCapture = {
            id: response.id,
            contingencyUpload: self.documentUpload,
            flagCallFE: "false"
          };

          $instantService
            .callbackMobileCapture(inputForCallBackMobileCapture)
            .then(function (response) {
              if (!response.success) {
                $rootScope.$broadcast("pageLoader", {
                  action: "CLOSE",
                });
              } else {
                self.intervalOfRepeatListenMobileCapture = setInterval(
                  function () {
                    $instantService
                      .listenMobileCapture(inputListenMobileCapture)
                      .then(function (response) {
                        numberOfIteration++;
                        if (
                          response.success &&
                          response.details.uploadCompleted
                        ) {
                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE",
                          });
                          /* uno */

                          self.titolareIesimo.documento.dataRilascio = self.titolareIesimo.documento.dataRilascio ? self.titolareIesimo.documento.dataRilascio : response.ocrResponse.documento.dataRilascio;
                          self.titolareIesimo.documento.dataScadenza = self.titolareIesimo.documento.dataScadenza ? self.titolareIesimo.documento.dataScadenza : response.ocrResponse.documento.dataScadenza;
                          self.titolareIesimo.documento.luogoEsteso = self.titolareIesimo.documento.luogoEsteso ? self.titolareIesimo.documento.luogoEsteso : response.ocrResponse.documento.luogoEsteso;
                          self.titolareIesimo.documento.enteRilascio.name = self.titolareIesimo.documento.enteRilascio.name ? self.titolareIesimo.documento.enteRilascio.name : response.ocrResponse.documento.enteRilascio && response.ocrResponse.documento.enteRilascio.name;
                          self.titolareIesimo.documento.provincia = self.titolareIesimo.documento.provincia ? self.titolareIesimo.documento.provincia : response.ocrResponse.documento.provincia;
                          self.titolareIesimo.documento.numero = self.titolareIesimo.documento.numero ? self.titolareIesimo.documento.numero : response.ocrResponse.documento.numero;

                          $rootScope.$broadcast("addAlert", {
                            text: "MSG_SEND_FILE_OK"
                          });
                          self.titolareIesimo.documento.docSubmitted = true
                          self.closeModalUploadDocument();

                        }
                        if (numberOfIteration >= 50) {
                          self.enableLoader = false;
                          $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                          });

                          $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TIMEOUT_LISTEN_MOBILE"
                          });

                          clearInterval(
                            self.intervalOfRepeatListenMobileCapture
                          );
                        }
                        console.log(
                          "Numero di iterazioni",
                          numberOfIteration
                        );
                        response.ocrResponse.documento.luogoEsteso &&
                          self.upgradeList({
                            comune: self.titolareIesimo.documento.luogoEsteso.nome,
                          });
                      })
                      .catch(function (error) {
                        console.log(error);
                        self.enableLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                          action: "CLOSE",
                        });
                      });
                  },
                  10000
                );
              }
            })
            .catch(function (error) {
              console.log(error);
              self.enableLoader = false;
              $rootScope.$broadcast("pageLoader", {
                action: "CLOSE",
              });

              $rootScope.$broadcast("addAlert", {
                text: "ERROR_TIMEOUT_LISTEN_MOBILE",
              });
            });
        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      });


  };

  self.startUploadDocumentMobile = function () {
    self.enableLoader = true;
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN",
    });
    self.documentUpload = [];
    var person = {
      cf: self.titolareIesimo.cf,
      nome: self.titolareIesimo.nome && self.titolareIesimo.nome.toUpperCase(),
      cognome: self.titolareIesimo.cognome &&
        self.titolareIesimo.cognome.toUpperCase(),
      telefono: self.dealerUser.tel,
      documento: {
        tipo: self.titolareIesimo.documento.tipo,
      },
    };

    self.intervalOfRepeatListenMobileCapture = 0;
    var numberOfIteration = 0;
    var person = [Pf.build(person)];
    var listOfDocument = [{
      id: "imgDocument",
      order: 2,
      fronteRetro: true,
      documentType: null,
      labelName: null,
      labelDescription: null,
      label: "DOC_IDENTITA_LBL",
      mocaDocumentTypes: [
        "identita-fronte",
        "identita-retro"
      ]
    }]
    $financialApiService
      .startMobileCaptureAdv(
        person,
        self.vendorPhone,
        true,
        self.startQuestionario.id,
        self.titolareIesimo.cf,
        self.startQuestionario.metadataAdv.cliente.common.cf,
        listOfDocument
      )
      .then(function (response) {
        if (response.success) {
          var inputListenMobileCapture = {
            id: response.id,
          };

          self.intervalOfRepeatListenMobileCapture = setInterval(
            function () {
              $instantService
                .listenMobileCapture(inputListenMobileCapture)
                .then(function (response) {
                  numberOfIteration++;
                  if (
                    response.success &&
                    response.details.uploadCompleted
                  ) {
                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });
                    self.titolareIesimo.documento.dataRilascio = self.titolareIesimo.documento.dataRilascio ? self.titolareIesimo.documento.dataRilascio : response.ocrResponse.documento.dataRilascio;
                    self.titolareIesimo.documento.dataScadenza = self.titolareIesimo.documento.dataScadenza ? self.titolareIesimo.documento.dataScadenza : response.ocrResponse.documento.dataScadenza;
                    self.titolareIesimo.documento.luogoEsteso = self.titolareIesimo.documento.luogoEsteso ? self.titolareIesimo.documento.luogoEsteso : response.ocrResponse.documento.luogoEsteso;
                    self.titolareIesimo.documento.enteRilascio.name = self.titolareIesimo.documento.enteRilascio.name ? self.titolareIesimo.documento.enteRilascio.name : response.ocrResponse.documento.enteRilascio && response.ocrResponse.documento.enteRilascio.name;
                    self.titolareIesimo.documento.provincia = self.titolareIesimo.documento.provincia ? self.titolareIesimo.documento.provincia : response.ocrResponse.documento.provincia;
                    self.titolareIesimo.documento.numero = self.titolareIesimo.documento.numero ? self.titolareIesimo.documento.numero : response.ocrResponse.documento.numero;
                    self.documentUpload = [];
                    var temp = {
                      name: response.ocrResponse.documento.imgDocumentoFront,
                      type: "imgDocument",
                      selected: false,
                      side: "front",
                      typeDocument: self.titolareIesimo.documento.tipo,
                      cdDoc: self.titolareIesimo.documento.tipo,
                      id: response.ocrResponse.documento.idImgDocumentoFront,
                      downloadKey: response.ocrResponse.documento.idImgDocumentoFront
                    };

                    self.documentUpload.push(temp);
                    var temp = {
                      name: response.ocrResponse.documento.imgDocumentoBack,
                      type: "imgDocument",
                      selected: false,
                      side: "back",
                      typeDocument: self.titolareIesimo.documento.tipo,
                      cdDoc: self.titolareIesimo.documento.tipo,
                      id: response.ocrResponse.documento.idImgDocumentoBack,
                      downloadKey: response.ocrResponse.documento.idImgDocumentoBack
                    };
                    self.documentUpload.push(temp);
                    self.titolareIesimo.documento.idImgDocumentoFront = response.ocrResponse.documento.idImgDocumentoFront;
                    self.titolareIesimo.documento.idImgDocumentoBack = response.ocrResponse.documento.idImgDocumentoBack;
                    $rootScope.$broadcast("addAlert", {
                      text: "MSG_SEND_FILE_OK"
                    });
                    self.titolareIesimo.documento.docSubmitted = true;
                    self.closeModalUploadDocument();
                  }
                  if (numberOfIteration >= 50) {
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                      action: "CLOSE",
                    });

                    $rootScope.$broadcast("addAlert", {
                      text: "ERROR_TIMEOUT_LISTEN_MOBILE",
                    });

                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                  }
                  console.log("Numero di iterazioni", numberOfIteration);
                  response.ocrResponse &&
                    self.upgradeList({
                      comune: self.titolareIesimo.documento.luogoEsteso.nome,
                    });
                })
                .catch(function (error) {
                  console.log(error);
                  self.enableLoader = false;
                  $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE",
                  });
                });
            },
            10000
          );
        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        self.showLoader = false;
        self.enableLoader = false;
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE",
        });
      });


  };



  /* fine sezione caricamento documenti */

  self.riabilita = function (index) {
    self.model[index].riattivatoFe = true;
    self.model[index].annullatoFe = false;
    validateComponent();
  }


  self.annulla = function (index) {
    self.model[index].annullatoFe = true;
    self.model[index].riattivatoFe = false;
    validateComponent();
  }

  var calculateFakeCf = function (indice) {
    if (self.newTitAdded[indice] && !self.newTitAdded[indice].cf && self.newTitAdded[indice].nome && self.newTitAdded[indice].cognome && self.newTitAdded[indice].sesso && self.newTitAdded[indice].datiNascita.nazione && self.newTitAdded[indice].data && self.newTitAdded[indice].isEstero) {
      var codCityOfBirth = self.listaNazioni.find(function (element) {
        return element.name.toUpperCase() == self.newTitAdded[indice].datiNascita.nazione.toUpperCase()
      }).value
      self.newTitAdded[indice].cf = validationService.createCf(self.newTitAdded[indice].nome, self.newTitAdded[indice].cognome, self.newTitAdded[indice].data, self.newTitAdded[indice].sesso, codCityOfBirth)
      self.verifyDate(indice);
    }
  }

  var createListForNewTit = function () {
    var indice = self.model.length - 1;

    self.listaNomeRilascio[indice] = Documento.getEntiRilascio(
      self.model[indice].documento.tipo
    );

    self.listaNomeComuniRilascio[indice] = self.mapComuni
      .filter(function (comune) {
        return comune.sigla == self.model[indice].documento.provincia;
      });
  }

  var ricreaModelli = function () {
    self.newTitAdded = self.model.filter(function (element) {
      return !element.ndg
    });
    self.newTitAdded.forEach(function (element, index) {
      self.listaComuniNascita[index] = self.mapComuni
        .filter(function (comune) {
          return comune.sigla == element.datiNascita.provincia;
        });
      if (element.datiNascita.provincia && element.datiNascita.provincia.toUpperCase() != 'EE' && element.datiNascita.provincia.toUpperCase() != 'SE') {
        self.verifyDate(index, true)
      }
    })
    self.model = self.model.filter(function (element) {
      return element.ndg
    });
    self.model.forEach(function (element, index) {
      if (element && element.sedeLegale && element.sedeLegale.stato) {
        element.sedeLegale.stato.name = element.sedeLegale.stato.name && element.sedeLegale.stato.name.toUpperCase();
      }
      if (element && !element.documento) {
        element.documento = Documento.build();
      }
      self.listaNomeRilascio[index] = element.documento && element.documento.tipo && Documento.getEntiRilascio(
        element.documento.tipo
      );
    })
  }

}